import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from '../context/ProtectedRoute';
import LeadgenDashboard from '../projects/ESID-25-013/pages/dashboard';

function LeadgenRoutes({setLoading, triggerAlert, settings}) {
  return (
    <Routes>
      <Route path="dashboard" element={
        <ProtectedRoute project="esid-25-013">
          <LeadgenDashboard setLoading={setLoading} triggerAlert={triggerAlert} settingsProps={settings} />
        </ProtectedRoute>
      } />

    </Routes>
  );
}

export default LeadgenRoutes;
